import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {SubscribedComponent} from "../subscribed.component";
import {NbToastrService} from "@nebular/theme";

@Component({
    selector: 'bst-callback',
    template: `<p style="padding: 10px">logging in...</p>`,
    styleUrls: [],
    standalone: false
})
export class CallbackComponent extends SubscribedComponent{

  constructor(private route: ActivatedRoute,
              private toast: NbToastrService,
              private router: Router) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    if(window && window.opener){
      window.opener.postMessage(true, document.location.origin);
      return;
    }

    this.subs.push(this.route.queryParamMap.subscribe(async (map) => {
      if(map.has('error')){
        this.toast.danger(map.get('error'));
      }
      await this.router.navigate(['login']);
    }));
  }

  get wasopened(){
    return window && window.opener;
  }

  close() {
    window.close();
  }
}
